import { Injectable, Output, ComponentRef } from '@angular/core';

@Injectable()

export class NotificationRef {
  @Output() compRef: any;

  constructor(private _cmptRef: ComponentRef<any>) {
    _cmptRef.instance.dismissEvent.subscribe(() => {
      this.dismiss();
    });
    this.compRef = this._cmptRef;
  }

  close(any?: any): void {
    if (this._cmptRef) {
      this.removeNotification();
    }
  }

  dismiss(any?: any): void {
    if (this._cmptRef) {
      this.removeNotification();
    }
  }

  private removeNotification() {
    const windowNativeEl = this._cmptRef.location.nativeElement;
    windowNativeEl.parentNode.removeChild(windowNativeEl);
    this._cmptRef.destroy();
  }
}
